'use client';

import { useTranslations } from 'next-intl';
import { Camera } from 'lucide-react';
import { EmptyState } from '@/shared/ui/EmptyState';

interface ProjectEmptyStateProps {
  onUploadPhoto: () => void;
  isArchived?: boolean;
}

export function ProjectEmptyState({
  onUploadPhoto,
  isArchived,
}: ProjectEmptyStateProps) {
  const tAngles = useTranslations('angles');
  const tProject = useTranslations('project');

  if (isArchived) {
    return (
      <EmptyState
        icon={<Camera />}
        title={tProject('projectIsArchived')}
        description={tProject('projectIsArchivedMessage')}
      />
    );
  }

  return (
    <EmptyState
      icon={<Camera />}
      title={tAngles('noAngles')}
      description={
        <>
          {tAngles('noAnglesDescription')}
          <span className="mt-2 block">{tAngles('noAnglesHint')}</span>
        </>
      }
      action={{
        label: tAngles('addAngle'),
        onClick: onUploadPhoto,
      }}
    />
  );
}
